import { isReportBuilderArtifact } from "@/components/artifacts/openArtifactDestination";
import type { Artifact, ReviewArtefactRef, TaskDetail } from "@/services/api/agentic-v2/types";

const DECK_KINDS = new Set([
  "advice_session_deck",
  "starter_session_deck",
  "plan_cheat_sheet",
]);

/** Decks open in the read-only deck viewer, which has no per-document approve. */
export function isReviewDeckKind(kind: string | null | undefined): boolean {
  return Boolean(kind && DECK_KINDS.has(kind));
}

export function isReviewDeckArtefact(
  artifact: Artifact,
  ref?: ReviewArtefactRef | null,
): boolean {
  if (isReviewDeckKind(ref?.kind ?? artifact.kind)) return true;
  return isReportBuilderArtifact(artifact);
}

/** A review is configured (catalogue review definition, journey or seeded panels); otherwise use the task thread. */
export function taskHasConfiguredReview(task: TaskDetail): boolean {
  return (
    Boolean(task.review_choreography || task.onboarding_journey || task.booking_journey) ||
    (task.review_context_panels?.length ?? 0) > 0
  );
}

const CATALOGUE_REVIEW_ATTENTION_STATUSES = new Set(["needs_review", "blocked"]);

/** Task has a catalogue ``review`` definition (guided steps) and is waiting on a human. */
export function taskNeedsCatalogueReviewWorkspace(
  task: Pick<TaskDetail, "status" | "review_choreography">,
): boolean {
  if (!CATALOGUE_REVIEW_ATTENTION_STATUSES.has(task.status)) return false;
  return (task.review_choreography?.steps?.length ?? 0) > 0;
}
